var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-casestudy-bg",class:{'isWhite': _vm.isWhite}})
}
var staticRenderFns = []

export { render, staticRenderFns }